import { createVanIconComponent } from "./van"

const Search = createVanIconComponent("search")
export default Search
